import SearchFormLocation from './SearchFormLocation';

export default SearchFormLocation;
